import React from 'react';
import Computer from '@pixum/svg-icon/lib/Custom/Computer';
import { Linux } from '@pixum/svg-icon/lib/Custom/Linux';
import { Apple } from '@pixum/svg-icon/lib/Custom/Apple';
import { Windows } from '@pixum/svg-icon/lib/Custom/Windows';

export const osMap: Record<string, { name: string; icon: React.ReactNode }> = {
  Windows: {
    name: 'win',
    icon: <Windows key="icon-windows" />,
  },
  Linux: {
    name: 'linux',
    icon: <Linux key="icon-linux" />,
  },
  'Mac OS': {
    name: 'mac',
    icon: <Apple key="icon-apple" />,
  },
};

export const getOperationSystemIcon = (osName: string) => ({
  os: osMap[osName]?.name ?? '',
  icon: osMap[osName]?.icon ?? <Computer key="icon-computer" />,
});
